module.exports = __webpack_public_path__ + "img/emoji_45.b8f5f3a2.png";